import { ActionCard } from "./ActionCard.js";
import { ACTION_CARD_COUNTS } from "@/game-rules/constants/actionCardCounts.js";

export class Banzai extends ActionCard {
    static typeId = "BANZAI";
    static cardName = "Banzaï !";
    static colorHex = "#FF3232";
    static countInDeck = ACTION_CARD_COUNTS.BANZAI;
    static description = "Déplacez l’un de vos moutons de la ligne en 1ère position et décalez les autres derrière vous pour remplir la ligne.";

    isValidOn(slotIndex, gameState) {
        if (slotIndex === 0) return false;
        const duck = gameState.lineOfFire[slotIndex];

        // Can only target own duck that can go to first slot
        return duck.team?.id === gameState.getCurrentPlayerTeamId();
    }

    resolve(slotIndex, gameState) {
        gameState.banzai(slotIndex);
    }
}
